import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'phoneNumber'})
export class PhoneNumberPipe implements PipeTransform {
    transform(value: number): string {
        const numString = (value) ? value.toString().trim() : '';
        const match = numString.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        // If we don't pass the regEx give back the original value as a string
        return numString;
    }
}
